<template>
  <div>
    <section class="content-header">
      <h1>My Wallet</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Account</a>
        </li>
        <li class="breadcrumb-item active">My Wallet</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-xl-4">
          <wallet></wallet>
        </div>

        <div class="col-12 col-sm-8 col-md-8 col-xl-8">
          <div class="box">
            <div class="box-header with-border">
              <h4 class="box-title">Request a Withdrawal</h4>
              <div class="box-controls pull-right">
                <p class="mb-0">
                  <i class="fa fa-money"></i>
                </p>
              </div>
            </div>
            <div class="box-body">
              <form @submit.prevent="createWithdrawal">
                <div class="form-group">
                  <label class="mr-25">Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-dollar pl-5 pr-3"></i>
                    </span>
                    <input
                      v-model="model.value"
                      class="form-control"
                      type="number"
                      value="0"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="mr-25">
                          {{
                            (model.withdrawal_type === "regular" &&
                              "USDT Wallet") ||
                            "bbusiness Username"
                          }}
                        </label>
                        <router-link
                          v-if="model.withdrawal_type === 'regular'"
                          class="float-right text-success"
                          :to="{ name: 'Profile.dashboard' }"
                          >(Edit Here)</router-link
                        >
                        <div class="input-group">
                          <span class="input-group-addon">
                            <template
                              v-if="model.withdrawal_type === 'regular'"
                            >
                              <cryptoicon symbol="usdt" size="25" />
                            </template>
                            <template v-else>
                              <img src="/images/icon.jpg" class="eleven-icon" />
                            </template>
                          </span>
                          <template v-if="model.withdrawal_type === 'transfer'">
                            <input
                              class="form-control bg-dark text-white"
                              type="text"
                              v-model="model.receiver_user"
                            />
                          </template>
                          <template v-else>
                            <input
                              :disabled="true"
                              class="form-control bg-dark"
                              type="text"
                              v-model="model.wallet"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for>WITHDRAW TYPE</label>
                        <select
                          class="form-control border-success"
                          v-model="model.withdrawal_type"
                        >
                          <option :value="'regular'">Crypto Network</option>
                          <!-- <option :value="'transfer'">
                            Transfer Balance to User
                          </option> -->
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-12">
                      <email-auth-code
                        @code-changed="(evt) => (model.email_auth_code = evt)"
                        labelClass="col-sm-12"
                        inputClass="col-sm-12"
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <h3 class="mb-0">Requests *</h3>
                <p>
                  All request must be greater than $100 and equal or less than
                  your balance.
                </p>
                <hr />
                <button
                  type="submit"
                  class="btn btn-success btn-block"
                  v-if="!loading"
                >
                  Request Now
                  <i class="icon-plane"></i>
                </button>
                <button type="submit" class="btn btn-success btn-block" v-else>
                  Loading
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </button>
              </form>
            </div>
          </div>
          <withdrawal-details />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import WithdrawalDetails from "@/views/Withdrawals/Details";
import { EmailAuthCode } from "@/components";
import Wallet from "@/components/Wallet";

export default {
  name: "balance",
  data() {
    return {
      model: {
        value: 0,
        fees: 0,
        total: 0,
        currency_id: 11,
        withdrawal_type: "regular",
        wallet: this.$store.getters["currentUser"].token_wallet,
        receiver_user: "",
      },
      loading: false,
    };
  },
  components: { EmailAuthCode, WithdrawalDetails, Wallet },
  watch: {
    "model.value": function (oldValue) {
      this.model.fees = (parseFloat(oldValue).toFixed(2) * 0.05).toFixed(2);
      this.model.total = (parseFloat(oldValue).toFixed(2) * 0.95).toFixed(2);
    },
    "model.withdrawal_type": function (newValue) {
      if (newValue === "regular")
        this.model.wallet = this.$store.getters["currentUser"].token_wallet;
      if (newValue === "transfer") this.model.wallet = "";
    },
  },
  methods: {
    createWithdrawal() {
      this.loading = true;
      this.$http({
        method: "post",
        url: "/api/v1/client/withdrawals",
        data: this.model,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$store.dispatch("getWithdrawals");
          this.$toasted.show("Widthdrawal requested!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.errors.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
